import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { getBearerToken, getCookies, getProfilePictureLink, isAdmin, dynamicResourceLinks, setCookies, useGoto } from "./util";
import $ from 'jquery'
import ControlPannel from "./ControlPannel";
import CustomLink from "./CustomLink";
import { globalContext } from "./App";
import { useContext } from "react";

const Profile = () => {
	const { loggedIn, setLoggedIn } = useContext(globalContext);
	const [key, setkey] = useState(0);

	let params = useSearchParams()[0];
	var searchquery = params.get("user")
	if (!isAdmin()) {
		searchquery = undefined
	}
	let [userdata, setUserData] =
		useState((() => {
			if (!searchquery || searchquery === getCookies().username) {
				return (
					{
						username: getCookies().username,
						author: getCookies().author,
						email: getCookies().email,
						role: getCookies().role
					}
				)
			}
			return ({
				username: "loading...",
				author: "...",
				email: "...",
				role: "..."
			})
		})());
	const [pimage, setpimage] = useState(userdata.username !== "loading..." ? getProfilePictureLink() : "");
	const initpimage = useRef(userdata.username !== "loading..." ? getProfilePictureLink() : "")
	// const [filechosen, setfilechosen] = useState(false);
	useEffect(() => {
		if (searchquery !==null) {
			axios.get(`https://api.pcbang.ma/api/users?populate=avatar,role&filters[username][$eq]=${searchquery}`,
				{
					headers: {
						Authorization: getBearerToken()
					}
				}
			).then((response) => {
				console.log({ response })
				console.log(response.data)
				// console.log(response.data[0].username)
				if (response && response.status === 200 && /*response.statusText === "OK" &&*/ response.data.length !== 0 && response.data.filter(user => user.username === searchquery).length === 1) {
					var user = response.data.filter(usr => usr.username === searchquery)[0]
					// console.log(user)
					setUserData({ ...user, author: user.name, role: user.role.name })
					setpimage("https://api.pcbang.ma" + user.avatar.url)
					initpimage.current = "https://api.pcbang.ma" + user.avatar.url
					console.log({ username: user.username })
				}
				else /*if (response.data.length === 0)*/ {
					setUserData({ username: `User ${searchquery} does not exist` })
				}
			})
		}
		else {
			setpimage(getProfilePictureLink())
			setUserData(
				{
					username: getCookies().username,
					author: getCookies().author,
					email: getCookies().email,
					role: getCookies().role
				}
			)
		}
		if (searchquery && searchquery !==getCookies().username) {
			$(".filechosen").attr("style", "display: none;")
		}
	}, [params, searchquery])
	// user is logged in
	var gotopassword = useGoto("/profile/password");
	var gotoedit = useGoto("/profile/edit")
	if (!loggedIn) return <></>
	return (
		<div className="profile pagebody">
			<div className="mainbody">
				<div className="navpad"></div>
				<ControlPannel {...{ loggedIn, setLoggedIn, key }}>
					{
						isAdmin()
							?
							<CustomLink className="users left"
								to={"/users"}
							>
								<img src={dynamicResourceLinks("ff09ff").userIcon} alt="" className="icon" />
								<div className="tooltip">
									manage users
								</div>
							</CustomLink>
							:
							<div></div>
					}
					<div></div>
				</ControlPannel>
				<div className="law7a">
					<div className="profileimagecard">
						<div style={{
							backgroundImage: "url(" + pimage + ")"
							, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center",
							overflow: "hidden"
						}} className="profileimage" >
						</div>
						<div className="username">{userdata.username}</div>
						<input type="file" id="imgupload" accept="image/*" onChange={(e) => {
							$(".filechosen").removeAttr("style")
							$(".actualupload").attr("style", "display: none;")
							console.log(e)
							var input = e.target
							if (input.files && input.files[0]) {
								console.log(input.files)
								console.log(input.files[0])
								var reader = new FileReader();
								reader.onload = function (e) {
									setpimage(e.target.result)
								};
								reader.readAsDataURL(input.files[0]);
							}
						}} style={{ display: "none" }} />
						<div className="upload actualupload"
							style={{
								...(searchquery && searchquery !==getCookies().username && { display: "none" })
							}}
							onClick={() => {
								$('#imgupload').trigger('click');
							}}
						>
							<div className="plussign">+</div>
							<div className="tooltip">
								Upload&nbsp;New&nbsp;Image
							</div>
						</div>
						<div style={{ display: "none" }} className="upload filechosen flex-jc-cr flex-gap5" onClick={() => {
							const data = new FormData()
							data.append("files", $("#imgupload")[0].files[0])
							axios.post("https://api.pcbang.ma/api/upload", data,
								{
									headers: {
										Authorization: getBearerToken(),
										'Content-Type': 'multipart/form-data'
									}
								}
							).then((res) => {
								console.log({ res })
								axios.put("https://api.pcbang.ma/api/users/me",
									JSON.stringify({
										avatar: res.data[0].id
									}),
									{
										headers: {
											Authorization: getBearerToken(),
											'Content-Type': 'application/json'
										}
									}
								).then((res2) => {
									console.log({ res2 })
									$("#update_img_status").text("Updated Profile Image")
									setCookies({ pfp: res.data[0].url })
									// setwm(!wm)
									setpimage(getProfilePictureLink())
									setkey(key + 1)
									setTimeout(() => {
										$("#update_img_status").text("")
										$(".filechosen").attr("style", "display: none;")
										$(".actualupload").removeAttr("style")
									}, 2000)

								}).catch((err2) => {
									console.log({ err2 })

								})
							}).catch((err) => {
								console.log({ err })
							})
						}}>
							<img src="https://img.icons8.com/ios-glyphs/24/ffffff/save--v1.png" alt="save" />
							<div>Save</div>
						</div>
						<div style={{ display: "none" }} className="upload filechosen" onClick={() => {
							$(".filechosen").attr("style", "display: none;")
							$(".actualupload").removeAttr("style")
							console.log(initpimage.current)
							setpimage(initpimage.current)
						}} >Cancel</div>
						<div style={{ display: "none" }} className="filechosen" id="update_img_status"></div>
					</div>
					<div className="userinfo">
						<div className="info username"><span>Username:&nbsp;</span><div>{userdata.username}</div></div>
						<div className="info author"><span>Author Name:&nbsp;</span><div>{userdata.author}</div></div>
						<div className="info email"><span>Email:&nbsp;</span><div>{userdata.email}</div></div>
						<div className="info role"><span>Role:&nbsp;</span><div>{userdata.role}</div></div>
						<div className="container w100 flex-jc-cr flex-ai-cr flex-gap10 flex-wrap">
							<div className="edit flex-grow flex-shrink-0"
								style={{
									...(searchquery && searchquery !==getCookies().username && { display: "none" })
								}}
								onClick={gotoedit}
							>
								<img src={dynamicResourceLinks("ffffff").editPenIcon} alt="" />
								<div className="tooltip" style={{ whiteSpace: "nowrap" }}>Edit Profile Info</div>
							</div>
							<div className="edit flex-grow flex-shrink-0"
								style={{
									...(searchquery && searchquery !==getCookies().username && { display: "none" })
								}}
								onClick={gotopassword}
							>
								<img src={dynamicResourceLinks("ffffff").passwordKeyIcon} alt="" />
								<div className="tooltip" style={{ whiteSpace: "nowrap" }}>Change Password</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Profile;